/** Account accent colors — same palette as MailWorkspace rail avatars. */
export const CAL_ACCENT_FALLBACK = [
  '#ea4335',
  '#0078d4',
  '#00796b',
  '#6d28d9',
  '#c2410c',
  '#0f766e',
]

export function providerAccent(provider: string | null | undefined): string {
  const p = (provider || '').toLowerCase()
  if (p === 'gmail' || p === 'google') return '#ea4335'
  if (p === 'microsoft' || p === 'outlook') return '#0078d4'
  if (p === 'yahoo') return '#6001d2'
  if (p === 'gmx') return '#1c449b'
  if (p === 'custom' || p === 'imap') return '#00796b'
  return '#6d28d9'
}

export function resolveAccountAccent(opts: {
  accountId: string | null | undefined
  provider?: string | null
  index?: number
  prefColor?: string | null
}): string {
  const fallback =
    providerAccent(opts.provider) ||
    CAL_ACCENT_FALLBACK[(opts.index ?? 0) % CAL_ACCENT_FALLBACK.length]
  const pref = (opts.prefColor || '').trim()
  if (pref.startsWith('#') && (pref.length === 4 || pref.length === 7)) return pref
  return fallback.startsWith('#') ? fallback : CAL_ACCENT_FALLBACK[0]
}
